/* eslint-disable max-len */
import { h } from 'preact';
import clsx from 'clsx';
import { useState, useEffect } from 'preact/hooks';
import Price from '../product/product-price';
import Image from '../utils/image';
import ScentColors from '../product/product-scent-colors';
import { formatMetaobjectList } from '../utils/helpers';
import AddToCartButton from '../product/product-add-to-cart';
import Badges from '../product/product-badges';
import { formatProduct } from '../utils/storefront/format-resource';
import YotpoStars from '../product/product-stars';

function ProductCard({
  currentProduct,
  customClass = '',
  disableHover = false,
  hideATC = false,
  disableScentColor = false,
}) {
  const currentVariant = currentProduct?.variants?.edges[0]?.node;

  const scentColors = formatMetaobjectList(
    currentProduct?.scentColors?.references?.edges,
  );
  const badgesData = JSON.parse(
    document.querySelector('[data-badges]').textContent,
  );

  const isRedirect = currentProduct?.forcePdpATC?.value;
  const hoverImageIndex = isRedirect ? 0 : 1;

  const variantImage = currentVariant?.image?.url
  const hoverImage = currentProduct?.productCardHoverImage
    ? currentProduct?.productCardHoverImage?.reference?.image?.url
    : currentProduct?.images?.edges[hoverImageIndex]?.node?.src || variantImage;
  const compareAtPriceBadge = currentProduct?.compareAtPriceBadge?.value;
  const customPromotions =
    currentVariant?.compareAtPrice === null &&
    currentProduct?.compareAtPriceBadge?.value === 'false'
      ? currentProduct?.excludePromo?.value
      : 'false';
  const [isKits, setIsKits] = useState(false);

  const kitOptionGroups = [
    {
      products:
        currentProduct?.kitOptionGroup1?.references?.nodes.map(formatProduct),
      label: currentProduct?.kitOptionGroup1Label?.value,
      key: 'kitOptionGroup1',
    },
  ];
  // eslint-disable-next-line no-unused-expressions
  !kitOptionGroups[0].products ? setIsKits(false) : setIsKits(true);

  const [isVoyage, setIsVoyage] = useState(false);
  useEffect(() => {
    setIsVoyage(
      String(currentProduct?.title).toLowerCase().includes('voyage')
    )
  }, [currentProduct?.title]);


  return (
    <div
      className={clsx(
        'relative col-span-1 bg-cream-grey',
        customClass,
        !disableHover && 'group laptop:cursor-pointer',
      )}
      data-product-card
    >
      <div className={clsx(hoverImage && 'block')}>
        <a
          href={`${window.Shopify.routes.root}products/${currentProduct?.handle}`}
          className={clsx(
            'h-0 relative pt-[80%] block link-unstyled',
            !hoverImage && 'laptop:group-hover:hidden',
          )}
        >
          {hoverImage && (
            <div
              className={clsx(
                'hidden laptop:group-hover:block',
                hoverImage && 'absolute inset-x-0 top-0 -bottom-px z-10',
              )}
            >
              <a
                href={`${window.Shopify.routes.root}products/${currentProduct?.handle}`}
                className={clsx(
                  'h-full relative block link-unstyled',
                  !hoverImage && 'pt-[80%] !h-0',
                )}
              >
                <Image
                  src={hoverImage}
                  alt=""
                  srcWidths={{
                    sm: 326,
                    md: 650,
                  }}
                  classes={clsx(
                    'block w-full absolute top-0 left-0 h-full object-cover ',
                    hoverImage.includes('white-background') && 'mix-blend-multiply',
                  )}
                />
              </a>
              {!hideATC && (
                <AddToCartButton
                  data-product-card
                  currentVariant={currentVariant}
                  currentProduct={currentProduct}
                  showQty={false}
                  showPrice={!isKits}
                  isKits={isKits}
                  isMargin={false}
                  showMessage={false}
                  isProductCard={true}
                  isRedirect={isRedirect}
                  customClass="absolute bottom-2.5 left-2.5 max-w-[calc(100%-20px)] w-full z-[5]"
                />
              )}
            </div>
          )}
          <Badges
            currentProduct={currentProduct}
            oosBadge={
              currentProduct?.availableForSale
                ? false
                : badgesData.badges[0]?.standard_badge?.find(
                    (b) => b.name === 'oos',
                  )
            }
            isCardBadge={true}
            customClass="laptop:group-hover:hidden"
          />
          <Image
            src={currentVariant?.image?.url}
            alt=""
            srcWidths={{
              sm: 326,
              md: 650,
            }}
            classes={clsx(
              'block w-full absolute top-0 left-0 h-full object-cover z-[2]',
              currentVariant?.image?.url.includes('white-background') &&
                'mix-blend-multiply',
            )}
          />
          <AddToCartButton
              data-product-card
              currentVariant={currentVariant}
              currentProduct={currentProduct}
              showQty={false}
              showPrice={false}
              isKits={isKits}
              isMargin={false}
              showMessage={false}
              isProductCard={true}
              isRedirect={isRedirect}
              btnStyle='block text-black bg-transparent laptop:hidden rounded-full border w-[25px] h-[25px] flex items-center justify-center !p-0 border-black/30'
              customClass="absolute bottom-[5px] right-[5px] z-[5]"
            />
        </a>
        <div className="flex flex-col p-3 pt-0">
          <div className="flex items-center justify-start gap-[2.35px] mb-3 pt-3 border-t border-black-30">
            {!isVoyage && <YotpoStars
                currentProduct={currentProduct}
                currentVariant={currentVariant}
              />
            }
          </div>
          {!disableScentColor && (
            <ScentColors scentColors={scentColors} isProductCard={true} />
          )}
          <div className="mb-2">
            <a
              href={`${window.Shopify.routes.root}products/${currentProduct?.handle}`}
              className="text-black font-14"
            >
              {currentProduct?.title}
            </a>
          </div>
          <Price
            currentPrice={currentVariant.price}
            currentComparePrice={currentVariant.compareAtPrice}
            fontClass="font-13 text-charcoal"
            customContainerClass=""
            customPromotions={customPromotions}
            compareAtPriceBadge={compareAtPriceBadge}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
